export default "__VITE_ASSET__5b96dd2a__"